import { endpoints } from "@cayo/shared/services/endpoints.service";
import { oClient } from "@cayo/shared/libs/oDataClient";

type TenantPayload = {
  accountName: string;
  accountPassword?: string;
  servicePrincipalName?: string;
  accountToken: string;
  credentialUsage: string;
  configureChannels: boolean;
  systemTypes: string;
};

export function addTenant(
  data: TenantPayload,
  finished: (tenant: { [key: string]: any }) => void,
  setError: (error: string) => void
) {
  return new Promise((resolve, reject) => {
    fetch(`${endpoints.publicUrl}/v0/configuration/managedTenants/cayo.graph.addTenant`, {
      method: "POST",
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        const ok = response.ok;

        return await Promise.resolve({ ok, response });
      })
      .then(async ({ ok, response }) => {
        const clonedResponse = response.clone();
        const responseBody = await clonedResponse.json().catch(() => ({}));
        if (ok) {
          finished(responseBody);
          return resolve(ok);
        }

        setError(responseBody?.message || "");

        reject(response);
      })
      .catch((e) => reject(e));
  });
}

export async function getEntraApp(path: string) {
  return new Promise((resolve, reject) => {
    oClient(endpoints.publicUrl)
      .get(`v0/${path}/credentials`)
      .query({
        $select: "name",
      })
      .then((response) => {
        resolve(response);
      })
      .catch(() => reject());
  });
}
